import { FormBase } from 'core/components';
import validatorjs from 'validatorjs';

export default class RateCalculatorForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.setForm(this);
	}
	setup() {
		var Validator = validatorjs;
		Validator.register(
			'notZero',
			value => {
				return value != 0;
			},
			'NOTZEROVALUE'
		);
		return {
			fields: [
				'warehouseId',
				'shipFromZipCode',
				'shipToZipCode',
				'isResidentialRecipient',
				'productId',
				'weight',
				'length',
				'width',
				'height',
				'carrierIds[]',
				'showCheapestRate',
				'useThirdPartyAccounts',
			],
			labels: {
				productId: 'RATECALCULATOR.SKU',
				warehouseId: 'RATECALCULATOR.WAREHOUSE',
				shipFromZipCode: 'RATECALCULATOR.ZIPCODE',
				shipToZipCode: 'RATECALCULATOR.ZIPCODE',
				weight: 'RATECALCULATOR.WEIGHT',
				length: 'RATECALCULATOR.LENGTH',
				width: 'RATECALCULATOR.WIDTH',
				height: 'RATECALCULATOR.HEIGHT',
				carrierIds: 'RATECALCULATOR.CARRIERS',
				showCheapestRate: 'RATECALCULATOR.SHOWCHEAPESTRATE',
				useThirdPartyAccounts: 'RATECALCULATOR.THIRDPARTYACCOUNTS',
				isResidentialRecipient: 'RATECALCULATOR.RESIDENTIALRECIPIENT',
			},
			rules: {
				shipFromZipCode: 'required|numeric|notZero',
				shipToZipCode: 'required|numeric|notZero',
				weight: 'required|numeric|notZero',
				length: 'required|numeric|notZero',
				width: 'required|numeric|notZero',
				height: 'required|numeric|notZero',
			},
			values: {
				showCheapestRate: false,
				isResidentialRecipient: false,
				useThirdPartyAccounts: false,
			},
			types: {
				showCheapestRate: 'checkbox',
				isResidentialRecipient: 'checkbox',
				useThirdPartyAccounts: 'checkbox',
			},
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/rate-calculator/forms/RateCalculatorForm.js